import React from 'react'
import { Container, ContainerImg, BoxTexto, BoxTextoSpan, BoxTextoImg } from './Styled'
import bgConteudo from 'images/bg-assinatura-vitalicia.png'
import icDesconto from 'images/ic-assinatura-vitalicia.svg'

export default function Conteudo ({ desconto }) {

	const getMessage = () => {
		return desconto > 0 
		? `<strong>Acesse o site</strong> para entender o cálculo do seu desconto`
		: `<strong>Acesse o site</strong> saber se você tem direito ao desconto`
	}

	return (
		<Container background={bgConteudo}>
			<ContainerImg src={bgConteudo} />
			<a href='https://www.estrategiaconcursos.com.br/promocoes/vitalicia' target='_blank'>
				<BoxTexto>
					<BoxTextoSpan dangerouslySetInnerHTML={{__html: getMessage()}} />
					<BoxTextoImg src={icDesconto} />
				</BoxTexto>
			</a>
		</Container>
	)

}
